<template>
  <div class="story-card-container">
    <div class="story-card-wrapper "
         :class="{'is-marginless' : isMarginless, 'story-card-wrapper-isef' : $isIsef}">
      <router-link :to="path"
                   :event="'click'">
        <div @click="emitClick"
             aria-label="Click to view project"
             class="story-card"
             :class="{'is-mini' : isMini,
                       'flexible-height': flexibleHeight,
                       'adminJudge-height' : isAdminJudge,
                       'story-card-isef' : $isIsef,
                       'story-card-eng': $isEngCom,
                       'story-card-eng': $isOhioScience
                     }">
          <template v-if="!isBlank && !isRowLoading">
            <bookmark v-if="showBookmark && !isYscStemExpo"
                      :project="project"/>
            <slot />
            <slot name="lower" />
          </template>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>

import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'
import base from '../mixins/base'
import Bookmark from '../UI/Bookmark'

export default {
  components: {
    Bookmark
  },
  computed: {
    isAdminJudge: function () {
      return this.$route.name === 'adminJudge'
    },
    isIsefViewAll: function () {
      return this.$route.name !== 'home' && this.$isIsef
    },
    isYscStemExpo: function () {
      return this.$route.path.includes('stem-expo') && this.$isYSC
    }
  },
  props: {
    projectID: Number,
    categoryID: [Number, String],
    storyType: Boolean,
    isMarginless: [Boolean, String],
    isRowLoading: Boolean,
    isPinnableRow: Boolean,
    pinnedProjects: Array,
    size: [String, Number],
    disableLink: Boolean,
    fromSearch: Boolean,
    isMini: Boolean,
    showBookmark: {
      type: Boolean,
      default: true
    },
    displayType: String,
    flexibleHeight: Boolean
  },
  mixins: [auth, base, componentState]
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .story-card {
    height: 270px;
    width: 260px;
    border-radius: 4%;
    overflow: hidden;
    background-color: var(--background-story-card);
    position: relative;
    font-family: "Roboto";
    display: flex;
    flex-direction: column;
    @include tablet-only {
      width: 220px;
      height: 221px;
    }
    @include mobile {
      width: 164px;
      height: 201px;
    }
    @include hover-cards-effect;
    &-eng {
      border: thin solid rgba(65,66,71,.18);
      border-radius: 4%;
    }
    &-isef {
      width: 322px;
      height: 291px;
      background: #1D1B43;
      overflow: unset;
    }
  }
  .story-card.flexible-height {
    min-height: 270px;
    height: auto;
  }
  .story-card.adminJudge-height {
    min-height: auto !important;
  }
  .story-card.is-mini {
    width: 180px;
    @include tablet-only {
      width: 155px;
      height: 221px;
    }
    @include mobile {
      width: 135px;
      height: 201px;
    }
  }
  .story-card-wrapper {
    &-isef {
      margin-left: .58rem !important;
      &-viewAll {
        @include mobile {
          margin-left: 0 !important;
        }
      }
    }
    &:not(.is-marginless) {
      margin: 1rem;
      margin-left: 0;
      @include mobile {
        margin-right: 0.43rem;
      }
    }
  }
</style>
